import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-old-shipments-list',
  templateUrl: './old-shipments-list.component.html',
  styleUrls: ['./old-shipments-list.component.scss']
})
export class OldShipmentsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
